import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

interface EditorialProcessProps {
  steps: string[];
}

// Une liste ordonnée, pas une liste à puces : ici le rang porte une information réelle, puisque les
// étapes s'enchaînent dans le temps. Sur Zéro déchet, où les cases étaient des alternatives, la
// numérotation aurait au contraire menti.
const useStyles = makeStyles((theme) => ({
  list: {
    // La numérotation est peinte à la main pour être mise en forme ; `counter-reset` la conserve
    // néanmoins portée par un `<ol>`, que les lecteurs d'écran annoncent comme une séquence.
    counterReset: 'editorial-step',
    listStyle: 'none',
    margin: 0,
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '1.25rem',
  },
  step: {
    counterIncrement: 'editorial-step',
    position: 'relative',
    paddingLeft: '3rem',
    minHeight: '2rem',
    fontSize: '0.95rem',
    lineHeight: 1.6,
    color: '#3d3d3d',

    '&:before': {
      content: 'counter(editorial-step)',
      position: 'absolute',
      left: 0,
      top: 0,
      width: '2rem',
      height: '2rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '50%',
      backgroundColor: theme.palette.client.primary.main,
      color: '#fff',
      fontFamily: 'Bitter, serif',
      fontWeight: 700,
      fontSize: '0.9rem',
    },
  },
}));

const EditorialProcess: React.FC<EditorialProcessProps> = ({ steps }) => {
  const classes = useStyles();

  return (
    <ol className={classes.list}>
      {steps.map((step) => (
        <li key={step} className={classes.step}>
          {step}
        </li>
      ))}
    </ol>
  );
};

export default EditorialProcess;
